import React from 'react';
import { ProductData } from '../types/askStanley.types';
import { createIconElement } from '@/lib';
import IcPlus from '@/assets/icons/ic-plus.svg';

interface ProductDisplayProps {
    product: ProductData;
    index: number;
    onClick: () => void;
}

interface ProductTypeConfig {
    label: string;
    tagClassName: string;
    imageContainerClassName: string;
}

const PRODUCT_TYPE_CONFIGS: Record<string, ProductTypeConfig> = {
    'digital-download': {
        label: 'Digital Product',
        tagClassName: 'bg-neutral-subtle text-gray',
        imageContainerClassName: 'bg-brand-subtle',
    },
    digital_download: {
        label: 'Digital Product',
        tagClassName: 'bg-neutral-subtle text-gray',
        imageContainerClassName: 'bg-brand-subtle',
    },
    meeting: {
        label: 'Meeting',
        tagClassName: 'bg-brand-subtle text-brand-main',
        imageContainerClassName: 'bg-brand-subtle',
    },
    webinar: {
        label: 'Webinar',
        tagClassName: 'bg-brand-subtle text-brand-main',
        imageContainerClassName: 'bg-brand-subtle',
    },
    course: {
        label: 'Course',
        tagClassName: 'bg-brand-subtle text-brand-main',
        imageContainerClassName: 'bg-brand-subtle',
    },
};

export const ProductDisplay: React.FC<ProductDisplayProps> = ({ product, onClick }) => {
    const productData = product.product;
    const productType = product.type;

    // Get config for product type or use default
    const config: ProductTypeConfig = PRODUCT_TYPE_CONFIGS[productType] || {
        label: productType || 'Product',
        tagClassName: 'bg-neutral-subtle text-gray',
        imageContainerClassName: 'bg-neutral-subtle',
    };

    return (
        <div className='bg-canvas rounded-md p-4 shadow-md'>
            <div className='space-y-3'>
                {/* Product Type Tag */}
                <div className='flex justify-start'>
                    <span className={`caption-2-bold rounded-full px-3 py-1 capitalize ${config.tagClassName}`}>
                        {config.label}
                    </span>
                </div>

                {/* Product Card Content */}
                <div className='flex items-start gap-3'>
                    {/* Product Image */}
                    {productData.image && (
                        <div className={`flex-shrink-0 rounded-lg p-2 ${config.imageContainerClassName}`}>
                            <img src={productData.image} alt={productData.title} className='size-6 object-cover' />
                        </div>
                    )}

                    {/* Product Info */}
                    <div className='min-w-0 flex-1'>
                        <h4 className='heading-h3 text-dark mb-1'>{productData.title}</h4>
                        {productData.subtitle && (
                            <p className='caption-1-regular text-gray line-clamp-2'>{productData.subtitle}</p>
                        )}
                    </div>

                    {/* Plus Button */}
                    <button
                        className='bg-brand-subtle hover:bg-brand-soft flex-shrink-0 rounded-full p-2 transition-colors hover:cursor-pointer'
                        onClick={() => onClick()}
                    >
                        {createIconElement(IcPlus, { className: 'size-4 text-brand-main' })}
                    </button>
                </div>
            </div>
        </div>
    );
};
